export function getHeroContent() {
  return {
    title: "TAILORED FOR YOU",
    description:
      "Your goals shape our solutions. At Tenth Corporation, we turn your challenges into opportunities and your ideas into action. Every success you achieve is a win we celebrate together.",
    backgroundImage: "/assets/images/Solutionsbg.jpg",
  };
}

export const flagshipProducts = [
  {
    image: "/assets/images/HRIT.jpg",
    title: "Human Resource Information Technology",
    description:
      "Streamlined HR management platform for efficient staff administration and organizational planning.",
    features: [
      "Records Management",
      "Organizational and Staffing",
      "Payroll Management",
      "Time and Attendance Management",
      "Learning and Development",
      "Performance Management",
      "Rewards and Recognition",
      "Employee Self-Service",
    ],
    route: "/hris",
  },
  {
    image: "/assets/images/solution1.jpg",
    title: "Document Management System",
    description:
      "Secure and efficient solution for document storage, retrieval, and workflow management.",
    features: [
      "Document Processing and Receiving",
      "Accounts Management",
      "Records Management",
      "Workflow Management",
      "Dashboard and Reports",
      "System Management",
    ],
    route: "/dms",
  },
  {
    image: "/assets/images/barangayIF.jpg",
    title: "Barangay Information System",
    description:
      "Smart barangay information system designed to simplify local government operations and resident services.",
    features: [
      "Resident Database Management",
      "Incident Reporting",
      "Local Service Tracking",
      "Community Communication Tools",
      "Service Request Management",
      "Reports Generation and Analysis",
    ],
    route: "/bis",
  },
];

export const getFooterContent = () => ({
  backgroundColor: "#96B596",
  text: "© 2025 Tenth Corporation Inc. All Rights Reserved",
});
